<template>
  <div class="editor-input">
    <simple-editor
      :editor-data="data"
      :image-style="imageStyle"
      :hideEditorBtn="hideEditorBtn"
      @onButtonExec="handleButtonExec"
      @onChange="handleEditorChange"
      @onFocus="handleFocus"
      @onBlur="hanldeEditorBlur"
    ></simple-editor>
    <slot></slot>
  </div>
</template>

<script>
// components
import SimpleEditor from "@/views/editor/simple-editor";

export default {
  name: "EditorInput",
  components: {
    SimpleEditor
  },
  props: {
    value: {
      type: [String, Object],
      default: ""
    },
    imageStyle: {
      type: Object,
      default: () => ({})
    },
    hideEditorBtn: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: "value",
    event: "changeData" // 这个event的值'input'对应$emit触发的事件'input'
  },
  data() {
    return {
      data: typeof this.value == "string" ? this.value : this.value.data ? this.value.data : ""
    };
  },

  mounted() {},
  beforeDestroy() {},

  methods: {
    handleEditorChange(editorData) {
      this.$emit("changeData", {
        type: "simpleEditor",
        data: editorData
      });
    },
    hanldeEditorBlur() {
      this.$emit("onBlur");
    },
    handleFocus() {
      this.$emit("onFocus");
    },
    handleButtonExec(key, id, data) {
      this.$emit("onButtonExec", key, id, data);
    }
  }
};
</script>

<style lang="less" scoped>
.editor-input {
  position: relative;
  width: 100%;
  min-width: 60px;
  height: 100%;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.6);
  color: #373737;
  font-size: inherit;
  font-weight: inherit;
}

.resize {
  position: absolute;
  right: -5px;
  bottom: 0;
  z-index: 100;
  width: 0;
  height: 0;
  border-top: 10px solid #333;
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
  transform: rotate(-45deg);
  cursor: nwse-resize;
}
</style>
